<template>
  <div class="home_block_4">
    <div class="hb4_right" :style="rightTopStyle">
      <div :class="{'book-img anim-opacity-0-1':true,'active1':bookCurrent.active1}" @mouseover="clearTimer"
           @mouseout="initTimer">
        <EiStarLight class="star-light">
        </EiStarLight>
      </div>
      <!--            <div :class="{'book-name anim-opacity-0-1':true,'active1':bookCurrent.active1}">
                      <span>{{bookCurrent.name}}</span>
                  </div>-->
      <div class="total-img">
        <!--                <img :src="logoUrl" alt="">-->
      </div>
      <!--            <div class="total-text">-->
      <!--                <span>双勾原创 • 合作出版</span>-->
      <!--            </div>-->
    </div>
  </div>
</template>

<script>

import {queryHomeBlockInHomeAction} from '@/api/reception/home-api'
import {isFailure} from '@/eiuov-utils/axios/response'
import {queryBookListAction} from '@/api/reception/book-api'

export default {
  name: "EiHomeBlock4",
  props: {

    speed: {
      type: Number,
      default: 100
    },
  },
  data() {
    return {
      leftTopStyle: {},
      rightTopStyle: {},
      bottomStyle: {},
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      logoUrl: '/upload/logo/logo-www.png',
      changeTimer: null,
      bookCurrent: {
        index: 0,
        name: '',
        url: '',
        active1: true,
        wordsActive: false
      },
      homeBlockList: [],
      bookList: []
    }
  },
  computed: {
  /*  classOption() {
      return {
        step: 0.6, //数值越大速度滚动越快
        limitMoveNum:330, //开始无缝滚动的数据量
        hoverStop: false, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      };
    },
    classOption2() {
      return {
        step: 0.5, //数值越大速度滚动越快
        limitMoveNum:this.isUsedList.length, //开始无缝滚动的数据量
        hoverStop: false, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      };
    },*/
  },
  created() {
    queryHomeBlockInHomeAction({blockName: '首页模块4'}).then((res) => {
      if (isFailure(res)) return
      this.homeBlockList = res.data.list
      this.initHomeBlockList(this.homeBlockList)
    })
    queryBookListAction({}).then((res) => {
      if (isFailure(res)) return
      this.bookList = res.data.list
      this.initBookList(this.bookList)
    })
  },
  methods: {
    initHomeBlockList(list) {
      if (list.length === 0) return
      this.leftTopStyle = this.getBackGroundImage(list, '左上');
      this.rightTopStyle = this.getBackGroundImage(list, '右上');
      this.bottomStyle = this.getBackGroundImage(list, '下');
    },
    initBookList(list) {
      if (list.length === 0) return
      this.bookCurrent.name = list[0].name
      /*	this.bookCurrent.url = list[0].attach.url*/
      this.initTimer()
    },
    getBackGroundImage(list, name) {
      if (list.length === 0) return {};
      for (let i = 0; i < list.length; i++) {
        if (list[i].blockName === name && list[i].picture !== null) {
          return {
            backgroundImage: 'url(' + list[i].picture.url + ')'
          }
        }
      }
      return {}
    },
    initTimer() {
      this.changeTimer = setInterval(() => {
        this.changeBook()
      }, 6000)
    },
    clearTimer() {
      clearInterval(this.changeTimer)
      this.changeTimer = null
    },
    changeBook() {
      this.bookCurrent.active1 = false
      setTimeout(() => {
        this.bookCurrent.active1 = true
        this.bookCurrent.index++
        if (this.bookCurrent.index >= this.bookList.length) this.bookCurrent.index = 0
        this.$set(this.bookCurrent, 'name', this.bookList[this.bookCurrent.index].name)
        let url;
        if (this.bookList[this.bookCurrent.index].attach) url = this.bookList[this.bookCurrent.index].attach.url
        else url = ''
        this.$set(this.bookCurrent, 'url', url)
      }, 600)
    },
    /* toWorkDetail() {
       this.$router.push("/WorksDetail")
     }*/
  }
}
</script>
<style scoped lang="scss">
.home_block_4 {
  margin: 60px auto;
  width: 1600px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;

  .hb4_left {
    width: 465px;
    height: 490px;
    background-color: rgb(162, 124, 74);

    .works-title {
      width: 100%;
      margin-top: 20px;
      text-align: center;
    }
  }
  .hb4_right {
    width: 1600px;
    height: 490px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    /*  background-color: #7C1A21;*/
    margin-bottom: 20px;
    position: relative;

    // 星光装饰定位（px 由 postcss 自动转 vw）
    .star-light {
      position: absolute;
      margin-left: -155px;
      margin-top: -30px;
    }

    .total-img {
      position: absolute;
      left: 50px;
      bottom: 20px;

      img {

        height: 70px;
      }
    }

    .total-text {
      position: absolute;
      font-size: 26px;
      right: 200px;
      bottom: 30px;
      color: white;
      line-height: 50px;
      border-top: #A67B4C 1px solid;
    }

    .book-img {
      position: absolute;
      top: 30px;
      left: 150px;

      img {
        height: 330px;
      }
    }

    .book-name {
      position: absolute;
      width: 350px;
      text-align: center;
      font-size: 26px;
      right: 150px;
      bottom: 50px;
      color: white;
    }
  }

  .title-wrap {
    width: 80%;
    margin: 35px auto 5px;
    height: 50px;
    text-align: center;

    img:first-child {
      width: 25px;
      margin-right: 20px;
      vertical-align: middle;
    }

    img:last-child {
      width: 25px;
      margin-left: 20px;
      vertical-align: middle;
      transform: scaleX(-1);
    }

    span {
      display: inline-block;
      font-size: 28px;
      vertical-align: middle;
      line-height: 50px;
      color: #fff;
    }
  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
